import { Box, Tab, Tabs, Typography } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import useAPI from "../../../../../../api/hooks/useAPI";
import useColors from "../../../../../../api/hooks/useColors";
import { entityKeys } from "../../../../../../api/queryKeys";
import PrimaryButton from "../../../../../../components/buttons/PrimaryButton";
import { isLocalhost } from "../../../../../../utils/utils";
import OSVersionManagementChart from "./osVersionDistribution/OSVersionManagementChart";
import ManagementSLAChart from "./slaChart/ManagementSLAChart";
import VulnerabilityManagementChart from "./vulnerabilitiesChart/VulnerabilityManagementChart";

const EndpointChart = ({ entities, appliedFilters, setAppliedFilters }) => {
  const { fetchVulnerabilitiesByEntityType, trackEvent } = useAPI();

  // Check if running in localhost
  const isLocalhostEnv = isLocalhost();
  const [cvesFetchDisabled, setCvesFetchDisabled] = useState(true);

  const { refetch: refetchVulnerabilities } = useQuery({
    queryKey: entityKeys.vulnerabilitiesByEntityType("host"),
    queryFn: () => {
      return fetchVulnerabilitiesByEntityType("host");
    },
    select: (response) => response?.data,
    enabled: !isLocalhostEnv || !cvesFetchDisabled,
  });

  const tabData = [
    //TODO: for future use https://linear.app/breeze-security/issue/DEV-2857/implement-endpoint-cves-chart-in-inventory-page
    { label: "OS Version Management", content: OSVersionManagementChart },
    {
      label: "Vulnerability Management",
      content: VulnerabilityManagementChart,
    },
    { label: "SLA Performance", content: ManagementSLAChart },
  ];
  const [value, setValue] = useState(0);
  const colors = useColors();
  const handleChange = (_, newValue) => {
    setValue(newValue);
  };

  const ChartToRender = tabData[value].content;
  return (
    <Box sx={{ width: "100%" }}>
      <Tabs
        value={value}
        onChange={handleChange}
        variant="scrollable"
        scrollButtons="auto"
        sx={{
          "& .MuiTab-root": {
            textTransform: "none",
            fontWeight: 500,
            color: colors.text_secondary,
            padding: "12px 16px",
          },
          "& .Mui-selected": {
            color: colors.text_primary,
            fontWeight: 700,
            background: "#FFF",
            borderRadius: "8px 8px 0 0",
            boxShadow: "0px -1px 4px 2px  rgba(0, 0, 0, 0.1)",
          },
          textTransform: "none",
          "& .MuiTabs-indicator": {
            backgroundColor: "transparent",
            height: 3,
          },
        }}
      >
        {tabData.map((tab, index) => (
          <Tab
            key={index}
            label={<Typography variant="subtitle2">{tab.label}</Typography>}
            sx={{ textTransform: "none" }}
          />
        ))}
      </Tabs>
      <Box sx={{ backgroundColor: colors.grey_100 }}>
        {isLocalhostEnv && (
          <Box
            sx={{
              p: 2,
              textAlign: "right",
              backgroundColor: colors.common_white,
            }}
          >
            {cvesFetchDisabled && (
              <PrimaryButton
                variant="contained"
                size="small"
                onClick={() => {
                  setCvesFetchDisabled(false);
                  refetchVulnerabilities();
                  trackEvent("User enabled CVE data fetching in localhost");
                }}
              >
                Enable CVE Data Fetching
              </PrimaryButton>
            )}
          </Box>
        )}
        <ChartToRender
          entities={entities}
          appliedFilters={appliedFilters}
          setAppliedFilters={setAppliedFilters}
        />
      </Box>
    </Box>
  );
};

export default EndpointChart;
